import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "card-group" }
const _hoisted_8 = { class: "card bg-light" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "card bg-light" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "card bg-light" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "list-group" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_22 = { class: "mb-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { class: "mb-1" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { key: 4 }
const _hoisted_34 = { class: "text-right" }

import { computed, onMounted, watch } from 'vue'
    import { usePageReloaded, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelinesDashboardPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDashboardPage',
  setup(__props) {

    document.title = "Manage pipelines"

    const reloaded = usePageReloaded()
    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, usePipelinesDashboardQuery, useLastRunsQuery } = useAdminPipelinesDashboardPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelPipelinesDashboardQueryV1, runPipelinesDashboardQueryV1 } = usePipelinesDashboardQuery(tid)
    const organiationUnitId = computed(() => modelPipelinesDashboardQueryV1.value?.OrganizationUnitId)
    
    const { modelLastRunsQueryV1, runLastRunsQueryV1 } = useLastRunsQuery(organiationUnitId, reloaded)
    const lastRuns = computed(() => modelLastRunsQueryV1.value?.Runs || [])

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelinesDashboardQueryV1()
    })

    watch(organiationUnitId, () => runLastRunsQueryV1())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Pipelines", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/create/${organiationUnitId.value}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Create pipeline ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "card-title" }, "Pipelines", -1 /* CACHED */)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "card-text" }, "Browse and manage your pipelines to import or export data.", -1 /* CACHED */)),
            _createElementVNode("a", {
              href: `/#/admin/integrations/pipelines/manage/${organiationUnitId.value}`,
              class: "btn btn-primary"
            }, "All pipelines", 8 /* PROPS */, _hoisted_10)
          ]),
          _createCommentVNode("<div class=\"card-footer\">\n                        <small>6 active | 2 recent</small>\n                    </div>")
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-title" }, "Connectors", -1 /* CACHED */)),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "card-text" }, "See and manage connectors that are used to read from or write to them data from datasets.", -1 /* CACHED */)),
            _createElementVNode("a", {
              href: `/#/admin/integrations/connectors/manage/${organiationUnitId.value}`,
              class: "btn btn-primary"
            }, "All connectors", 8 /* PROPS */, _hoisted_13)
          ]),
          _createCommentVNode("<div class=\"card-footer\">\n                        <small>27 runs today | Last: Pipeline1</small>\n                    </div>")
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "card-title" }, "Datasets", -1 /* CACHED */)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "card-text" }, "Datasets are storing data for pipelines. Can be shared or pipline scoped", -1 /* CACHED */)),
            _createElementVNode("a", {
              href: `/#/admin/integrations/datasets/manage/${organiationUnitId.value}`,
              class: "btn btn-primary"
            }, "All datasets", 8 /* PROPS */, _hoisted_16)
          ]),
          _createCommentVNode("<div class=\"card-footer\">\n                        <small>12 datasets | 3 shared</small>\n                    </div>")
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_17, [
        _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Last runs", -1 /* CACHED */)),
        _createElementVNode("a", {
          href: `/#/admin/integrations/runs/manage/${organiationUnitId.value}`
        }, "See all runs", 8 /* PROPS */, _hoisted_18)
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lastRuns.value, (r) => {
          return (_openBlock(), _createElementBlock("a", {
            key: r.RunId,
            href: `/#/admin/integrations/runs/details/${organiationUnitId.value}/${r.RunId}`,
            class: _normalizeClass(["list-group-item list-group-item-action", {'list-group-item-secondary': r.Queued, 'list-group-item-primary': r.Running, 'list-group-item-success': r.Succeed, 'list-group-item-danger': (r.Failed || r.Aborted) && !r.Succeed}])
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _createElementVNode("h6", _hoisted_22, [
                  (r.Running)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "[Running]"))
                    : (r.Succeed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "[Succeed]"))
                      : (r.Failed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "[Failed(" + _toDisplayString(r.FailuresCount) + ")]", 1 /* TEXT */))
                        : (r.Aborted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "[Aborted]"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, "[Queued]")),
                  _createTextVNode(" " + _toDisplayString(r.PipelineName), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_28, [
                  _createTextVNode(_toDisplayString(r.Trigger) + " ", 1 /* TEXT */),
                  (r.QueuedByName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "by " + _toDisplayString(r.QueuedByName), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", null, _toDisplayString(r.QueuedAtSinceNow) + " ago", 1 /* TEXT */),
                  (r.StartedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "/ started " + _toDisplayString(r.StartedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (r.CompletedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "/ completed " + _toDisplayString(r.CompletedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (r.FailedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "/ failed " + _toDisplayString(r.FailedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (r.AbortedAtSinceNow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, "/ aborted " + _toDisplayString(r.AbortedAtSinceNow) + " ago", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("small", null, _toDisplayString(r.LastActivityAtSinceNow) + " ago", 1 /* TEXT */),
                _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("small", null, _toDisplayString(r.Duration), 1 /* TEXT */)
              ])
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_20))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */))
    ])
  ]))
}
}

})